import { forwardRef, chakra } from '@chakra-ui/react-v2';
import type { HTMLChakraProps } from '@chakra-ui/react-v2';
import type { MouseEventHandler } from 'react';

import { IconButton } from '@frontend/legacy-components';
import {
  SearchIcon,
  CloseIcon,
} from '@frontend/legacy-components/src/components/mediaAndIcons/icons/iconSet';

import { useSearchInputStyles } from './SearchInputStylesContext';
import { useSearchInputContext } from './utils/SearchInputContext';

export type SearchInputRightElementProps = HTMLChakraProps<'div'>;

export const SearchInputRightElement = forwardRef<
  SearchInputRightElementProps,
  'div'
>((props, ref) => {
  // Get props that are shared between search input
  const {
    paddingRight,
    isSubmitMode,
    isSubmitEnabled,
    isLiveEnabled,
    isDisabled,
    isReadOnly,
    onClear,
    onSubmit,
    size,
  } = useSearchInputContext();
  // Get field style from search input element custom theme
  const { element: elementStyles } = useSearchInputStyles();

  const mouseDownHandler: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
  };

  return (
    <chakra.div
      ref={ref}
      __css={{ ...elementStyles, right: 0 }}
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="end"
      gap={1}
      width={paddingRight}
      px={1}
      {...props}
    >
      {isLiveEnabled && (
        <IconButton
          size={size}
          color="feature.secondary"
          onMouseDown={mouseDownHandler}
          onClick={onClear}
          isDisabled={isDisabled}
        >
          <CloseIcon />
        </IconButton>
      )}
      {isSubmitMode && (
        <>
          {isSubmitEnabled && (
            <IconButton
              size={size}
              color="feature.secondary"
              onClick={onClear}
              isDisabled={isDisabled || isReadOnly}
            >
              <CloseIcon />
            </IconButton>
          )}
          <IconButton
            size={size}
            color="feature.secondary"
            onClick={onSubmit}
            isDisabled={isDisabled || isReadOnly}
          >
            <SearchIcon />
          </IconButton>
        </>
      )}
    </chakra.div>
  );
});
SearchInputRightElement.displayName = 'SearchInputRightElement';
